import { GridColumnType } from "../../../data/gridColumnType";

// eventListTableConfig
export const ViewGMPCourseTableConfig = {
    columns: [
        {
            name: "ID",
            fieldName: "cpidNumber",
            allowShort: false,
            colType: GridColumnType.Text,
        },
        {
            name: "Course Provider Name",
            fieldName: "organisationName",
            colType: GridColumnType.Text,
        },
        {
            name: "UENNumber",
            fieldName: "uenNumber",
            colType: GridColumnType.Text,
        },
        {
            name: "Submission Date",
            fieldName: "courseSubmittedDate",
            allowShort: false,
            colType: GridColumnType.DATE,
            colSettings: {
                format: "DD MMM YYYY",
            },
        },
        {
            name: "Status",
            fieldName: "courseProviderStatusName",
            colType: GridColumnType.Text,
        },
        {
            name: "Action",
            colType: GridColumnType.ACTION,
            defaultAction: {
                allowEdit: false,
                allowDelete: false
            },
            customAction: [
                {
                    name: "Process",
                    onViewAction: ( data ) =>
                    {
                        alert( "called permissions" );
                    },
                },
            ],
        },
    ],
};
